<template>
  <c-box v-if="attributes && attributes" :mb="{ base: 'md', sm: '3xl' }">
    <c-heading
      as="h4"
      :fontSize="{ base: 'md', sm: '2xl' }"
      :fontWeight="{ base: 700, sm: 400 }"
      :mb="{ base: 'lg', sm: '2xl' }"
      >{{ label }}</c-heading
    >
    <Field v-for="attribute in attributes" :key="attribute.id" :label="attribute.label">
      <c-list listStyleType="none" m="0">
        <c-list-item
          v-for="(value, index) in handleValue(attribute.value)"
          :key="`value-${attribute.id}-${index}`"
          m="0"
        >
          <c-text as="span" v-if="isBoolean(attribute) && value === 'false'">
            <c-text as="span" d="inline-block" h="1px" w="20px" m="3px 0" bg="gray.400"></c-text>
          </c-text>
          <c-text as="span" v-else-if="isBoolean(attribute)" p="0 10px 0 0">
            <c-text
              as="span"
              d="inline-block"
              transform="rotate(45deg)"
              h="15px"
              w="8px"
              border="2px solid var(--chakra-colors-brand-purple)"
              borderTopWidth="0"
              borderLeftWidth="0"
            ></c-text>
          </c-text>
          <c-text as="span" v-else>{{ addUnit(value, attribute) }}</c-text>
        </c-list-item>
      </c-list>
    </Field>
  </c-box>
</template>

<script lang="ts">
import Field from "@/design-system/elements/Field.vue";
import Heading from "@/design-system/elements/Heading.vue";
import { CBox, CHeading, CList, CListItem, CText } from "@chakra-ui/vue";
import { IProductAttribute } from "@iloq/shared";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "ProductFieldGroup",
  components: {
    Heading,
    Field,
    CList,
    CListItem,
    CText,
    CHeading,
    CBox,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    attributes: {
      type: Array as PropType<IProductAttribute[]>,
      required: true,
    },
  },
  methods: {
    addUnit(value: string, attribute: IProductAttribute): string | null {
      if (!value) {
        return null;
      }
      let v: any = value;
      let postfix = "";
      switch (attribute.unit) {
        case "CELSIUS":
          postfix = "°C";
          break;
        case "FAHRENHEIT":
          postfix = "°F";
          break;
        case "GRAM":
          try {
            v = Number(v);
          } catch (e) {
            // Ok, keep as the original number
          }
          postfix = " g";
          break;
        case "OUNCE":
          try {
            v = Number(v);
          } catch (e) {
            // Ok, keep as the original number
          }
          postfix = " oz";
          break;
        case "MILLIMETER":
          try {
            v = Number(v);
          } catch (e) {
            // Ok, keep as the original number
          }
          postfix = " mm";
          break;
        case "METER":
          try {
            v = Number(v);
          } catch (e) {
            // Ok, keep as the original number
          }
          postfix = " m";
          break;
        case "INCH":
          try {
            v = Number(v);
          } catch (e) {
            // Ok, keep as the original number
          }
          postfix = '"';
          break;
        default:
          postfix = "";
          break;
      }
      return v + postfix;
    },
    isBoolean(attribute: IProductAttribute): boolean {
      return attribute.unit === "BOOLEAN";
    },
    handleValue(value: string): string[] | null {
      if (!value) {
        return null;
      }
      return value.split(/[;\n]/g);
    },
  },
});
</script>
